import { Button } from "@/components/button/Button"
import { ColumnDef } from "@tanstack/react-table"
import { UserRole, Worker } from "src/types"
import { PasswordResetCell } from "./passwordResetCell"
import { hasUserAccess } from "@/utils/user"

export const createColumns = ({
  userRole,
  setEdit,
}: {
  userRole: UserRole
  setEdit: (e: React.MouseEvent<HTMLButtonElement>, worker: Worker) => void
}): ColumnDef<Worker>[] => {
  return [
    {
      accessorKey: "id",
      header: "#",
      cell: ({ row }) => {
        return <div>{row.index + 1}.</div>
      },
    },
    {
      accessorKey: "name",
      header: "Darbinieks",
      cell: ({ row }) => {
        const og = row.original
        return (
          <>
            <div>{og.name}</div>
            {+og.coeficient ? (
              <div className="text-[var(--text-secondary)] text-sm">
                Koeficients: {og.coeficient}
              </div>
            ) : null}
          </>
        )
      },
    },
    {
      accessorKey: "username",
      header: "Lietotājvārds",
      cell: ({ row }) => {
        const og = row.original
        return (
          <>
            <div>{og.username}</div>
            <div className="text-[var(--text-secondary)] text-sm">
              {og.email}
            </div>
          </>
        )
      },
    },
    {
      accessorKey: "role",
      header: "Pieejas tiesības",
      cell: ({ row }) => {
        const og = row.original
        const districts: string[] =
          og.permissions?.districts?.map(({ name }) => name) ?? []
        let showDistricts = true
        let role = "Darbinieks"
        if (og.role & UserRole.SuperAdmin) {
          showDistricts = false
          role = "✅ Administrators"
        } else if (og.role & UserRole.Admin) {
          showDistricts = false
          role = "✅ Administrators"
        } else if (og.role & UserRole.Manager) {
          role = "📋 Menedžeris"
        }
        return (
          <>
            <div>{role}</div>
            {showDistricts ? (
              <div className="text-[var(--text-secondary)] text-sm">
                {districts.join(" | ")}
              </div>
            ) : null}
          </>
        )
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: hasUserAccess({
        neededRole: UserRole.Admin,
        userRole,
      })
        ? PasswordResetCell
        : () => <div></div>,
    },
    {
      accessorKey: "edit",
      header: "Darbības",
      cell: ({ row }) => {
        const og = row.original
        return hasUserAccess({
          neededRole: UserRole.Admin,
          userRole,
        }) ? (
          <Button variant="secondary" onClick={(e) => setEdit(e, og)}>
            Labot
          </Button>
        ) : (
          <div></div>
        )
      },
    },
  ]
}
